import { RevealText, FadeIn } from "../motion/Reveal";
import { SectionLabel } from "../motion/SectionLabel";
import { WHO, GEN } from "../../data/content";
import { VisionCarousel } from "./VisionCarousel";

export const WhoWeAre = () => {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative min-h-screen flex flex-col justify-center py-28 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <SectionLabel>{WHO.label}</SectionLabel>

        <RevealText
          as="h2"
          lines={["Entertainment is evolving.", "So are the stories", "people choose to watch."]}
          className="mt-8 font-display font-bold text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.98] max-w-5xl"
        />

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <FadeIn className="lg:col-span-5 group relative overflow-hidden rounded-2xl border border-white/10 aspect-[4/5]">
            <VisionCarousel images={GEN.visionCarousel} />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#050505]/70 via-transparent to-transparent" />
          </FadeIn>
          <div className="lg:col-span-6 lg:col-start-7 space-y-6">
            {WHO.paragraphs.map((p, i) => (
              <FadeIn key={i} delay={i * 0.08}>
                <p
                  className={`font-body leading-relaxed font-light ${
                    i === 1
                      ? "text-white text-xl md:text-2xl"
                      : "text-neutral-400 text-lg"
                  }`}
                >
                  {p}
                </p>
              </FadeIn>
            ))}
          </div>
        </div>

        <FadeIn delay={0.1}>
          <div className="mt-20 border-l-2 border-[#ff4500] pl-6 md:pl-10 max-w-4xl">
            <p className="font-display font-bold text-white text-3xl md:text-5xl leading-[1.08] tracking-tight">
              {WHO.purpose}
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
